import { createContext, useContext } from 'react';

export type RootContextProps = {
  getRootContainer: () => HTMLDivElement | null;
  getModalContainer: () => HTMLDivElement | null;
};

/**
 * The context provider for the app.
 */
const UIRootContext = createContext<RootContextProps>({
  getRootContainer: () => null,
  getModalContainer: () => null,
});

export default UIRootContext;

export const useUILibContainer = (): RootContextProps => {
  const context = useContext(UIRootContext);
  return context;
};
